import { styled, useTheme } from '@mui/material';
import { Typography } from '../Typography/Typography';
import { useTranslation } from 'react-i18next';

export interface ChipTypeProps {
    title?: string;
    label?: string;
    type: 'Need' | 'Want' | 'Wish' | 'Dream' | 'onTrack' | 'offTrack' | 'atRisk';
}

const getChipConfig = (t: any, type: ChipTypeProps['type'], theme: any) => {
    const map = {
        Need: { backgroundColor: theme.palette.semantic.bg.info, title: t('NEED') },
        Want: { backgroundColor: theme.palette.semantic.bg.brandLight2, title: t('WANT') },
        Wish: { backgroundColor: theme.palette.semantic.bg.error, title: t('WISH') },
        Dream: { backgroundColor: theme.palette.semantic.bg.warning1, title: t('DREAM') },
        Aspire: { backgroundColor: theme.palette.semantic.bg.warning1, title: t('ASPIRE') },
        onTrack: { backgroundColor: theme.palette.semantic.bg.success1, title: t('TEXT_ON_TRACK') },
        offTrack: { backgroundColor: theme.palette.semantic.int.negative, title: t('TEXT_OFF_TRACK') },
        atRisk: { backgroundColor: theme.palette.semantic.bg.warning2, title: t('TEXT_AT_RISK') },
        Desire: { backgroundColor: theme.palette.semantic.bg.error, title: t('DESIRE') }
    };
    return map[type];
};

interface StyledContainerProps {
    $bgColor: string;
}

const StyledGoalTypeContainer = styled('div')<StyledContainerProps>(({ theme, $bgColor }) => ({
    display: 'flex',
    alignItems: 'center',
    fontSize: '12px',
    fontWeight: 500,
    color: theme.palette.semantic.text.default,
    backgroundColor: $bgColor,
    height: '26px',
    padding: `3px ${theme.spacing(2)}`,
    borderRadius: theme.spacing(3),
    minWidth: '100px',
    width: 'max-content'
}));

export const Chip = ({ type, label }: ChipTypeProps) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const config = getChipConfig(t, type, theme);
    const backgroundColor = config?.backgroundColor ?? 'inherit';
    const title = label || (config?.title ?? type);
    return (
        <StyledGoalTypeContainer aria-label={title} $bgColor={backgroundColor}>
            <Typography variant="body1" label={title} />
        </StyledGoalTypeContainer>
    );
};
